import React, { useState, useEffect, useCallback } from 'react';
import { format, subDays } from 'date-fns';
import ReportLayout, { ReportTable, usePagination } from './ReportLayout';
import api from '../../utils/api';
import toast from 'react-hot-toast';

const COLS = [
  { key: 'date_communicated',        label: 'Date Issued' },
  { key: 'staff_name',               label: 'Employee' },
  { key: 'role',                     label: 'Role',      render: v => v ? v.replace(/_/g, ' ') : '–' },
  { key: 'pay_group',                label: 'Pay Group' },
  { key: 'issue_of_concern',         label: 'Issue',            render: v => <span className="max-w-xs block truncate" title={v}>{v || '–'}</span> },
  { key: 'details_of_discussion',    label: 'Discussion',       render: v => <span className="max-w-xs block truncate" title={v}>{v || '–'}</span> },
  { key: 'employer_required_actions',label: 'Required Actions', render: v => <span className="max-w-xs block truncate" title={v}>{v || '–'}</span> },
  { key: 'communicated_by_name',     label: 'Issued By' },
  { key: 'next_review_date',         label: 'Next Review' },
  { key: 'status',                   label: 'Status',    render: () => <span className="px-2 py-0.5 rounded-full bg-blue-100 text-blue-700 text-xs font-medium">Acknowledged</span> },
];

export default function StaffWarningAcknowledgement() {
  const [data, setData]         = useState([]);
  const [staff, setStaff]       = useState([]);
  const [loading, setLoading]   = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [startDate, setStart]   = useState(format(subDays(new Date(), 180), 'yyyy-MM-dd'));
  const [endDate, setEnd]       = useState(format(new Date(), 'yyyy-MM-dd'));
  const [staffId, setStaffId]   = useState('');
  const pagination = usePagination(data);

  useEffect(() => {
    api.get('/staff').then(r => setStaff(Array.isArray(r.data) ? r.data : [])).catch(() => {});
  }, []);

  const load = useCallback(() => {
    setLoading(true);
    const p = new URLSearchParams({ start_date: startDate, end_date: endDate });
    if (staffId) p.set('staff_id', staffId);
    api.get(`/reports/staff-warning-acknowledgements?${p}`)
      .then(r => { setData(r.data || []); pagination.reset(); })
      .catch(() => toast.error('Failed to load'))
      .finally(() => setLoading(false));
  }, [startDate, endDate, staffId]);

  useEffect(() => { load(); }, [load]);

  const selStaff = staff.find(s => s.id === staffId);
  const chips = [
    { label: 'Date Range', value: `${startDate} — ${endDate}` },
    ...(selStaff ? [{ label: 'Staff', value: `${selStaff.first_name} ${selStaff.last_name}`, onRemove: () => setStaffId('') }] : []),
  ];

  return (
    <ReportLayout title="Staff Warning Acknowledgement" data={data} filename="staff_warning_acknowledgement"
      columns={COLS} activeChips={chips} showFiltersPanel={showFilters} onToggleFilters={() => setShowFilters(v => !v)}
      filters={
        <div className="flex flex-wrap gap-4">
          <div><label className="block text-xs font-semibold text-slate-500 mb-1">Start Date</label>
            <input type="date" value={startDate} onChange={e => setStart(e.target.value)} className="input-field !w-auto text-sm" /></div>
          <div><label className="block text-xs font-semibold text-slate-500 mb-1">End Date</label>
            <input type="date" value={endDate} onChange={e => setEnd(e.target.value)} className="input-field !w-auto text-sm" /></div>
          <div><label className="block text-xs font-semibold text-slate-500 mb-1">Employee</label>
            <select value={staffId} onChange={e => setStaffId(e.target.value)} className="input-field !w-auto text-sm">
              <option value="">All Employees</option>
              {staff.map(s => <option key={s.id} value={s.id}>{s.first_name} {s.last_name}</option>)}
            </select></div>
          <div className="flex items-end">
            <button onClick={load} className="btn-primary text-sm px-4 py-2">Apply</button>
          </div>
        </div>
      }>
      <ReportTable columns={COLS} data={data} loading={loading} pagination={pagination} />
    </ReportLayout>
  );
}
